export const Bio = {
  name:  "Jemin Ambaliya",
  roles: [
    "Java Developer",
    "Android App Developer",
  ],
  description:
 "I am a dedicated Java Developer proficient in creating robust APIs and applications using technologies like Spring Boot and Hibernate. With a strong background in Android app development, I have successfully built and launched apps that have garnered significant downloads and user engagement. My passion lies in leveraging Java's capabilities to innovate and create seamless user experiences.",
  github: "https://github.com/jeminambaliya76",
  resume:
    "https://drive.google.com/file/d/1-5nPWi8waIfgIY2jZS_s-khaJTRKRLZv/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/jemin-ambaliya-37b359188/",
  twitter: "https://twitter.com/",
  insta: "https://www.instagram.com/jemin.ambaliya/",
  facebook: "https://www.facebook.com/profile.php?id=100091561122647&mibextid=LQQJ4d",
};

export const skills = [

  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://img.icons8.com/?size=100&id=lTKW3iI3wIT0&format=png&color=000000",
      },
      {
        name: "Spring Framework",
        image:
          "https://img.icons8.com/?size=100&id=90519&format=png&color=000000",
      },
      {
        name: "Spring Boot",
        image: "https://img.icons8.com/?size=100&id=90519&format=png&color=000000",
      },
      {
        name: "Spring Data JPA",
        image:
          "https://img.icons8.com/?size=100&id=2oBx9FpXcbLa&format=png&color=000000",
      },
      {
        name: "RESTful APIs",
        image:
          "https://img.icons8.com/?size=100&id=55497&format=png&color=000000",
      },
      {
        name: "Database Management",
        image:
          "https://img.icons8.com/?size=100&id=CjYpeVImOaFJ&format=png&color=000000",
      },
      {
        name: "MySQL",
        image:
          "https://img.icons8.com/?size=100&id=qGUfLiYi1bRN&format=png&color=000000",
      },
      {
        name: "Deployment",
        image: "https://img.icons8.com/?size=100&id=OXm1lLM9CjMA&format=png&color=000000",
      }
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://img.icons8.com/?size=100&id=lTKW3iI3wIT0&format=png&color=000000",
      },
      {
        name: "Kotlin",
        image:
          "https://img.icons8.com/?size=100&id=ZoxjA0jZDdFZ&format=png&color=000000",
      },
      {
        name: "XML",
        image:
          "https://img.icons8.com/?size=100&id=hldPIHbULUz9&format=png&color=000000",
      },
      {
        name: "Android Studio",
        image:
          "https://img.icons8.com/?size=100&id=xBW8JMtsQGFC&format=png&color=000000",
      },
      {
        name: "Retrofit",
        image:
          "https://img.icons8.com/?size=100&id=11961&format=png&color=000000",
      },
      {
        name: "Firebase",
        image:
          "https://img.icons8.com/?size=100&id=62452&format=png&color=000000",
      },
      {
        name: "Glide/Picasso",
        image:
          "https://img.icons8.com/?size=100&id=12084&format=png&color=000000",
      },
      {
        name: "Proguard",
        image:
          "https://img.icons8.com/?size=100&id=56331&format=png&color=000000",
      },
      {
        name: "SQLite",
        image:
          "https://img.icons8.com/?size=100&id=59952&format=png&color=000000",
      },
      {
        name: "Google Play Console",
        image:
          "https://img.icons8.com/?size=100&id=V5cGWnc9R4xj&format=png&color=000000",
      }
    ],
  },
    {
      title: "Frontend (BASIC)",
      skills: [
        {
          name: "React JavaScript",
          image:
            "https://img.icons8.com/?size=100&id=t4YbEbA834uH&format=png&color=000000",
        },
        {
            name:"JavaScript",
            image:"https://img.icons8.com/?size=100&id=Pd2x9GWu9ovX&format=png&color=000000",
        },
        {
            name:"HTML5",
            image:"https://img.icons8.com/?size=100&id=20909&format=png&color=000000",
        },
        {
            name:"API Integration",
            image:"https://img.icons8.com/?size=100&id=nyaTzeaU786Z&format=png&color=000000",
        },
        {
            name:"Version Control (Git)",
            image:"https://img.icons8.com/?size=100&id=63777&format=png&color=000000",
        }
      ],
    },

  {
    title: "Others",
    skills: [

      {
        name: "GitHub",
        image:
          "https://img.icons8.com/?size=100&id=63777&format=png&color=000000",
      },
             {
               name: "Admob & Meta Monetization",
               image:
                 "https://img.icons8.com/?size=100&id=J3caGozFXTk1&format=png&color=000000",
             },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Figma",
        image:
          "https://img.icons8.com/?size=100&id=W0YEwBDDfTeu&format=png&color=000000",
      },
      {
        name: "Ps Editing",
        image:
          "https://img.icons8.com/?size=100&id=NeNPFdj7MzXi&format=png&color=000000",
      },
      {
        name: "Campaign",
        image:
          "https://img.icons8.com/?size=100&id=BzYhiw2SbQdg&format=png&color=000000",
      }
    ],
  },
];

export const experiences = [

  {
    id: 0,
    img: "https://play-lh.googleusercontent.com/osCltYzSwziJ68Y7IaAB-QnF9hKz9otSJfI0DE_G0VhZLV8CJh1OEQIqy1aqsm23TvI",
    role: "Java Developer",
    company: "Vision Infotech",
    date: "Aug 2022 - July 2023",
    desc: "I designed and developed Restful APIs for project modules, implemented frontend features with HTML, CSS, and JavaScript, and developed Android applications using Java, integrating with databases via Spring Data JPA and Hibernate. I also created and maintained the Pregnancy Ovulation Calculator app, which achieved over 50,000 downloads and a 4.2-star rating on the Google Play Store.",
    skills: [
      "Java",
      "Spring Framework",
      "Spring Boot",
      "Spring Data JPA",
      "RESTful APIs",
      "Database Management",
      "MySQL",
      "Kotlin",
      "XML",
      "Android Studio",
      "Firebase",
      "SQLite",
      "Google Play Console"
    ]
      },{
        id: 1,
        img: "https://jeminambaliya.com/donotdelete/appgenixinfo.jpg",
        role: "Java Developer",
        company: "Appgenix Infotech",
        date: "Aug 2021 - July 2022",
        desc: "I developed server-side applications and APIs, integrating them with backend databases and ensuring robust performance through thorough testing of APIs and unit functionalities. Additionally, I collaborated closely with front-end developers to align on API specifications and data models.",
        skills: [
          "Java",
          "Kotlin",
          "XML",
          "Firebase",
          "MySQL",
          "C",
          "C++",
          "HTML",
        ]
              },
];

export const education = [
  {
    id: 0,
    img: "data:image/png;base64,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",
    school: "Trine University",
    date: "Aug 2023 - Present",
    grade: "3.86/4",
    desc: "I am currently pursuing a Master of Science in Information Science/Studies at Trine University, Detroit, MI, where I am studying core subjects in information science, engaging in practical database design and implementation projects, and exploring the latest trends and technologies in the field.",
    degree: "Information Science/Studies",
  },
  {
    id: 1,
    img: "https://blogassets.leverageedu.com/blog/wp-content/uploads/2019/09/23163810/Deemed-University.png",
    school: "Deemed University",
    date: "July 2018 - July 2021",
    grade: "7.27/10",
    desc: "I completed my Bachelor of Computer Application from Deemed University, Maharashtra, India, achieving a CGPA of 7.27/10.",
    degree: "Bachelor of Computer Application",
  }
];

export const projects = [
  {
    id: 11,
    title: "AskYourNeeds",
    date: "Aug 2021 - Aug 2023",
    description:
      "Developed the backend for the Ask Your Needs app, creating APIs for managing menu products, sub-products, and user authentication, including JWT token-based login and signup functionality for a seamless user experience.",
    image:
      "https://jeminambaliya.com/donotdelete/askyourneeds.jpg",
    tags: [
      "React Js",
      "PostgressSQL",
      "Node Js",
      "Express Js",
      "Redux",
      "React Flow",
    ],
    category: "web app",
    github: "",
    webapp: "https://play.google.com/store/apps/details?id=com.askyourneeds.android",
  },
  {
    id: 9,
    title: "Pregnancy Ovulation Calculator",
    date: "Aug 2021 - Aug 2023",
    description:
      "Developed the Pregnancy Ovulation Calculator app, featuring comprehensive pregnancy tracking tools like due date calculation, symptom management, and baby kick counting for a seamless and supportive user experience.",
    image:
      "https://jeminambaliya.com/donotdelete/pregnancy.jpg",
    tags: [
      "Docker",
      "AWS",
      "DuckDNS",
      "Eslint",
      "Husky",
      "CI/CD",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
    ],
    category: "android app",
    github: "",
    webapp: "https://play.google.com/store/apps/details?id=com.pregnancy.ovalution.tracker",
  },
  {
    id: 0,
    title: "Meditation - Relax Music",
    date: "Aug 2021 - Aug 2023",
    description:
      "Developed backend services for the Meditation - Relax Music app using Spring Boot, including API integrations for streaming music, user authentication, and playlist management.",
    image:
      "https://play-lh.googleusercontent.com/FbNmatU7I2R_HpocnHA2D_DMrvm1ZME4Qo1rkKBR6l9hwem8nI01IflZom4zZ_EA6jE=w2560-h1440-rw",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    github: "",
    webapp: "https://play.google.com/store/apps/details?id=com.meditationmusic.soundyoga",
    member: [
      {
        name: "Jemin Ambaliya",
        img: "https://lh3.googleusercontent.com/a/ACg8ocKFXgnlPjKBmMtegtGHGPAKq0GbIydAK-Y7ubDCnUttiv1j8Szl=s288-c-no",
        linkedin: "https://www.linkedin.com/in/jemin-ambaliya-37b359188/",
        github: "https://github.com/jeminambaliya76/",
      }
    ],
  },
  {
    id: 1,
    title: "Video Player HD All Format",
    date: "Aug 2021 - Aug 2023",
    description:
      "Developed the HD Video Player HD All Format app, featuring multi-format support, pop-up playback, file management, and advanced functions like video-to-audio conversion and background play for a seamless media experience.",
    image:
      "https://jeminambaliya.com/donotdelete/videoplayerallformat.webp",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "android app",
    github: "",
    webapp: "https://play.google.com/store/apps/details?id=net.hd.videodownlaoder.free",
  },
  {
    id: 2,
    title: "Diana and Roma Fake Video Call",
    date: "Aug 2021 - Aug 2023",
    description:
      "Developed the Diana Roma Prank Call, Chat app, offering lifelike fake calls, video chats, and fun games to entertain users and prank friends with hilarious Diana and Roma scenarios.",
    image:
      "https://play-lh.googleusercontent.com/IdLPWGPM_Ez0Rafcuqq52x8nAqnkx-NZloZWxZ3eiFWwD16SQtRwjwCqxQKudefFenqc=w2560-h1440-rw",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "android app",
    github: "",
    webapp: "https://play.google.com/store/apps/details?id=net.diana.roma.game",
    member: [
     {
            name: "Jemin Ambaliya",
            img: "https://lh3.googleusercontent.com/a/ACg8ocKFXgnlPjKBmMtegtGHGPAKq0GbIydAK-Y7ubDCnUttiv1j8Szl=s288-c-no",
            linkedin: "https://www.linkedin.com/in/jemin-ambaliya-37b359188/",
            github: "https://github.com/jeminambaliya76/",
          }
    ],
  },
  {
    id: 3,
    title: "Farel Prayoga Video Call Prank",
    date: "Aug 2021 - Aug 2023",
    description:
      "Developed backend services for the Farel Prayoga Video Call Prank using Spring Boot, including a music API, random video API, and integrated signup and login functionalities.",
    image:
      "https://jeminambaliya.com/donotdelete/farelprayogaa.jpg",
    tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    category: "web app",
    github: "",
    webapp: "https://play.google.com/store/apps/details?id=com.goldnew.farelproyogacall.videocall.siwacall.chat.prank",
  },
  {
    id: 10,
    title: "Like Nastya Video Call & Chat",
    date: "Aug 2021 - Aug 2023",
    description:
      "Developed and designed the Like Nastya Piano Tiles Game, featuring high-quality piano songs, smooth gameplay, and an engaging user interface for fans to enjoy offline.",
    image:
      "https://jeminambaliya.com/donotdelete/likenastyacall.jpg",
    tags: ["React Native", "JavaScript", "Axios"],
    category: "android app",
    github: "",
    webapp: "https://play.google.com/store/apps/details?id=com.nastyau.tileu",
  }
  ,
  {
    id: 5,
    title: "Library App",
    date: "Dec 2024",
    description:
      " The Manage Library App is a full-stack web application built with React (TypeScript) and Spring Boot, designed to streamline library operations by enabling users to manage books, track borrow/return records, and maintain user details efficiently. The frontend ensures a responsive and interactive experience, while the backend, powered by Spring Boot and MySQL, provides secure and scalable data management through RESTful APIs. Key features include book management, a borrowing system, and seamless database integration, showcasing my expertise in React, TypeScript, Spring Boot, and database management.",
    image:
      "https://www.phpzag.com/wp-content/uploads/2022/06/library-management-system-php-min.png",
    tags: ["React Js", "TypeScript", "SpringBoot"],
    category: "web app",
    github: "",
    webapp: "",
  },
  {
    id: 5,
    title: "Photo Generator using Spring AI and Spring Boot",
    date: "Jan 2025",
    description:
      "The Spring AI Application is a full-stack project built with Spring Boot and React, designed to integrate AI-powered chat, image generation, and recipe creation using OpenAI APIs. The backend features services and controllers for handling chat interactions, generating images, and parameterizing API requests, while the frontend provides a dynamic and responsive interface with React components, conditional rendering, and CSS styling. Key highlights include setting up API keys, resolving CORS issues, and seamlessly integrating AI functionalities, showcasing my expertise in Spring Boot, AI integration, React, and full-stack development.",
    image:
      "https://petapixel.com/assets/uploads/2024/01/iStock-800x420.jpg",
    tags: ["SpringBoot"],
    category: "web app",
    github: "",
    webapp: "",
  },{
      id: 6,
      title: "CricWave (Web Scraping) - Live Cricket Scores & News Platform",
      date: "Feb 2025",
     description:
        "CricWave is a full-stack cricket platform built with Spring Boot and React.js, designed to provide real-time cricket scores, match updates, team and player details, and the latest cricket news. The backend efficiently scrapes data from multiple sources, processes it, and serves it via REST APIs, while the frontend presents the information through an interactive and user-friendly interface. Key highlights include web scraping integration, real-time data updates, API optimization, and a seamless user experience, showcasing my expertise in Spring Boot, web scraping, API integration, and full-stack development.",
     image:
        "https://jeminambaliya.com/donotdelete/cricwave.png",
      tags: ["SpringBoot", "React.js", "Web Scraping"],
      category: "web app",
      github: "",
      webapp: ""
    }

//  {
//    id: 6,
//    title: "Breaking Bad",
//    date: "Jun 2021",
//    description:
//      "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
//    image:
//      "https://camo.githubusercontent.com/937774368308a82419f53dd6eeb4a8675780e119636488b4e3cfe5d34859a72a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
//    tags: ["React Js", "API", "Axios", "Node JS"],
//    category: "android app",
//    github: "https://github.com/rishavchanda/Breaking-Bad",
//    webapp: "https://breaking-bad-webapp.netlify.app",
//  },
//  {
//    id: 7,
//    title: "Quiz App",
//    date: "Dec 2020 - Jan 2021",
//    description:
//      "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
//    image:
//      "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
//    tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
//    category: "android app",
//    github: "https://github.com/rishavchanda/Quiz-Earn",
//    webapp: "https://github.com/rishavchanda/Quiz-Earn",
//  },
//  {
//    id: 8,
//    title: "Face Recognition",
//    date: "Jan 2021",
//    description:
//      "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
//    image:
//      "https://dontrepeatyourself.org/media/face-recognition-with-python-dlib-and-deep-learning_cezKZBj.png",
//    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
//    category: "machine learning",
//    github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
//    webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
//  },
];

